import { Component, OnInit } from '@angular/core';
import { BlogService } from 'src/app/api/blog.service';
import { BlogPostType, BlogPosts } from 'src/app/models/blog';
import { environment } from 'src/environments/environment';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'blog-posts',
  templateUrl: './blog-posts.component.html',
  styleUrls: ['./blog-posts.component.scss']
})
export class BlogPostsComponent implements OnInit {

  constructor(private blogService: BlogService, private localeService: LocaleService) { }

  loading = false;
  error = false;

  data: BlogPosts;

  ngOnInit() {
    this.getData();
  }
  getData() {
    this.blogService.get({
      type: BlogPostType.Post,
      categories: [environment.blog.homePage.category[this.localeService.currentLocale]],
      limit: environment.blog.homePage.postsNumber
    }).subscribe(response => {
      this.loading = false;
      this.data = response;
    }, err => {
      this.loading = false;
      this.error = true;
    })
  }

  unescapeTitle(text: string) {
    return decodeURI(text);
  }

}
